import React from "react"
import AuthForm from '../../components/Authorization'

export default function AuthorizationError() {
    return (
        <section>
            <AuthForm/>
        </section>
    )
}
